/* Paintly - the AI bar on collection pages. Roadmap item 4.

   Shows once N products have scrolled fully past the top of the screen, not after N
   pixels: the same pixel depth is a very different number of designs on a phone than
   on a laptop. A time floor stops a fast flick-scroll tripping it in three seconds.
   Dismissed once, gone for the session. Hidden while any drawer is open. */
(function () {
  var bar = document.querySelector('[data-pkai]');
  if (!bar) return;
  var grid = document.getElementById('product-grid');
  if (!grid) return;

  var NEED = parseInt(bar.getAttribute('data-after'), 10) || 50;
  var FLOOR = parseInt(bar.getAttribute('data-floor'), 10) || 15000;
  var KEY = 'pk_aibar_off';
  var born = Date.now();
  var dismissed = false;
  try { dismissed = sessionStorage.getItem(KEY) === '1'; } catch (e) {}

  function drawerOpen() {
    return !!document.querySelector('cart-drawer.active') ||
           document.body.classList.contains('overflow-hidden');
  }

  /* count only products entirely off the top: a row straddling the fold has not been
     looked past yet, and counting it makes the bar arrive a row early */
  function passed() {
    var n = 0, kids = grid.children;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i].getBoundingClientRect().bottom < 0) n++; else break;
    }
    return n;
  }

  /* "50 designs" alone would never fire on more than half the collections: measured
     against all 187 published ones, 98 are too short for 50 products to ever leave a
     phone screen. So the end of the grid counts too - somebody who has seen every
     design in the collection is in exactly the situation this bar is for. */
  function atEnd() {
    var r = grid.getBoundingClientRect();
    return r.bottom <= window.innerHeight + 80;
  }

  var raf = 0;
  function evaluate() {
    raf = 0;
    if (dismissed) { bar.classList.remove('pkai--up'); return; }
    bar.classList.toggle('pkai--hide', drawerOpen());
    var earned = passed() >= NEED || atEnd();
    bar.classList.toggle('pkai--up', earned && (Date.now() - born) >= FLOOR);
  }
  function schedule() { if (!raf) raf = requestAnimationFrame(evaluate); }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  /* the floor may expire while the customer is already deep in the page and no longer
     scrolling, so re-check once when it lapses rather than waiting for a scroll */
  setTimeout(schedule, FLOOR + 60);

  var mo = new MutationObserver(schedule);
  mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  var cd = document.querySelector('cart-drawer');
  if (cd) mo.observe(cd, { attributes: true, attributeFilter: ['class'] });

  var x = bar.querySelector('[data-pkai-x]');
  if (x) x.addEventListener('click', function (e) {
    e.preventDefault();
    dismissed = true;
    bar.classList.remove('pkai--up');
    try { sessionStorage.setItem(KEY, '1'); } catch (err) {}
  });

  schedule();
})();
